import * as React from 'react';
import { TimePicker as DesignTimePicker } from '@whalecloud/fdx';
import FormItem from '@whalecloud/page-builder-core/components/FormItem';

const TimePicker = ({ element, elementStyle }) => {
  const { formItemSettings, formSettings, settings, className = '' } = element.data;
  const { visible } = settings;
  return (
    <FormItem
      id={element.id}
      style={{
        ...elementStyle,
        visibility: visible
      }}
      {...formSettings}
    >
      <DesignTimePicker {...formItemSettings} className={className} />
    </FormItem>
  );
};

export default TimePicker;
